import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

const SlideOver = (props) => {
  const { open, setOpen, scroll, title} = props
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const navigate = useNavigate();

  const isUserTokenPresent = useSelector(store => store?.authentication?.user_token ? true : false);

  const profile_image = useSelector(
    (store) => store?.profileDetails?.profile_image
  );

  useEffect(() => {
    setUserLoggedIn(isUserTokenPresent)
  }, [isUserTokenPresent])

  const handleClick = ()=> {
    navigate('my-profile/user')
    setOpen(false)
  }

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="fixed inset-0" onClose={setOpen} style={{ zIndex: '9999' }}>
        <div className="absolute inset-0">
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-neutral-50 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-y-0 left-0 pr-10 max-w-full flex">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-500 sm:duration-700"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <div className="relative w-screen max-w-fit lg:max-w-md">
                <div className={`h-full w-72 flex flex-col py-6 bg-gradient-to-b from-white to-teal-500 shadow-xl ${scroll}`} >
                  <div className="flex justify-between px-4">
                    <Dialog.Title className="text-xs mt-1 font-medium text-black">
                      {userLoggedIn ?
                      <div className='flex'>
                          {profile_image ? (
                            <div className='ml-1 mr-1 h-5 w-5' onClick={handleClick}>
                              <img src={profile_image} alt="profile image" className="w-full h-full rounded-full"/>
                            </div>
                            ) : (
                            <div className='ml-1 ' onClick={handleClick}>
                              <FontAwesomeIcon
                                  className="mr-1 text-slate-600 text-xl"
                                  icon={faUserCircle}/>
                            </div>
                             )}
                          <p>{title}</p>
                      </div>:null}
                    </Dialog.Title>
                    <Transition.Child
                      as={Fragment}
                      enter="ease-in-out duration-500"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in-out duration-500"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <button
                        type="button"
                        className="rounded-md text-white focus:outline-none ml-5"
                        onClick={() => setOpen(false)}
                      >
                        <FontAwesomeIcon icon={faXmark} size="lg" className="text-gray-700 cursor-pointer" />
                      </button>
                    </Transition.Child>
                  </div>
                  <div className="mt-1 h-full flex-1 flex flex-col px-3 py-1">
                    {props.children}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

export default SlideOver